import React, { useCallback } from "react";
import { useLocation } from "react-router-dom";
import { Information } from "../../../../domain/information/Information";
import { Paths } from "../../../../Paths";
import { Mount } from "../../common/Mount";
import { AdminButtonArea } from "./AdminButtonArea";
import { useNavigate } from "react-router-dom";

export const InformationItem = React.memo(function InformationItem(props: Props) {
    const { information } = props;

    const navigate = useNavigate();

    const location = useLocation();

    // お知らせ詳細ページへ遷移
    const handleInformationClicked = useCallback(() => {
        navigate(`${Paths.information}/${information.id.value}`, { state: { from: location.pathname } });
    }, [history, location, information]);

    return (
        <li className={"row"} onClick={handleInformationClicked}>
            <div className="created_time">
                <p>{information.createdTime.date.format("/")}</p>
            </div>
            <div className={"info_content"}>
                <div className={"info_content__title"}>
                    <Mount if={!information.isRead}>
                        <div className="unread_mark"/>
                    </Mount>
                    <p>{information.title.value}</p>
                </div>
                <AdminButtonArea information={information} />
            </div>
        </li>
    );
});

type Props = {
    information: Information
}